<template>
  <div class="historyFrom">
    <el-card>
      <span class="title">历史记录</span>
      <el-divider></el-divider>
      <el-table :data="historyData" border style="width: 100%">
        <el-table-column prop="public_time" label="日期" width="173"> </el-table-column>
        <el-table-column prop="type_name" label="报名信息" width="584"> </el-table-column>
        <el-table-column prop="signup_job" label="报名职位" width="300"> </el-table-column>
        <el-table-column prop="regular" label="编制类型" width="100"> </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="1" :page-size="5"> </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      historyData: [
        {
          public_time: '',
          regular: '',
          signup_job: '',
          type_name: ''
        }
      ]
    }
  },
  created() {
    this.getHistoryApi()
  },
  methods: {
    // 获取历史信息api
    async getHistoryApi() {
      const { data: res } = await this.$axios.get('/api/signup/signupHistory')
      console.log(res)
      if (res.response_code == 200) {
        this.historyData = res.data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.historyFrom {
  @include autoInner();
  height: 700px;
  .el-card {
    height: 100%;
  }
  .title {
    font-size: 34px;
    display: block;
    padding-top: 30px;
  }
  .el-pagination {
    margin-top: 20px;
  }
}
</style>
